import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Popconfirm, Avatar } from 'antd';
import { LoadingOutlined, DeleteOutlined } from '@ant-design/icons';
import imageReservando from './../../images/ic_launcher.png';
import './styles.css';

const { Column } = Table;

const ServicesTableAdmin = ({ data, onDeleteService }) => {
    return (
        <Table className="servicesTableAdminCont" dataSource={data} rowKey={record => (record.key)} size="small" pagination={false}>
            <Column className="serviceCont" title="Servicio" dataIndex="service" key="service" align="center" />
            <Column title="Icono" dataIndex="icon" key="icon" align="center"
                render={icon => (
                    <Avatar size={32} src={(icon && icon.url) ? icon.url : imageReservando} />
                )}
            />
            <Column title="" dataIndex="isLoading" key="isLoading" align="center"
                render={(text, record) => (
                    <span>
                        {
                            record.isLoading ?
                                <Button type="primary" disabled={true}>
                                    <LoadingOutlined />
                                </Button>
                                :
                                <Popconfirm title="¿Desea borrar el servicio?" okText="SI" cancelText="NO" onConfirm={() => onDeleteService(record)}>
                                    <Button><DeleteOutlined /></Button>
                                </Popconfirm>
                        }
                    </span>
                )}
            />
        </Table>
    );
};

ServicesTableAdmin.propTypes = {
    data: PropTypes.array,
    onActionSelected: PropTypes.func,
};

export default ServicesTableAdmin;